Service = App.loadClass 'core::Angular/Service'

class exports.SidebarService extends Service

    constructor: (@http, @rootScope, @factory) ->
        null

    getCrops: =>
        return @http.post('backend/portal/ratings/load-crops')
        .then (response) -> response.data
        .then (response) =>
            if response.status?.type is 'success'
                # response.data.crops = _.map response.data.crops, (crop) =>
                for props, i in response.data.crops
                    crop = @factory.make('Crop', props)
                    response.data.crops[i] = crop
            return response
